import 'uni-pages';import '@dcloudio/uni-stat';

import Vue from 'vue'            
import Page from './pages/personalCenter/myInformation/email.vue'
createPage(Page)